import { InputLabelProps, TextField } from '@mui/material';
import React from 'react';

type TestInputProps = {
  children?: React.ReactNode;
  type?: string;
  name: string;
  label: string;
  value: unknown;
  errors?: Record<string, string[]>;
  select?: boolean;
  editable?: boolean;
  multiline?: boolean;
  rows?: number;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  inputLabelProps?: InputLabelProps | undefined;
};

function TextInput(props: TestInputProps): JSX.Element {
  const { children, name, label, value, errors, onChange, select, type, editable, multiline, rows, inputLabelProps } = props;

  return (
    <div>
      <TextField
        fullWidth
        error={errors && errors[name] !== undefined}
        helperText={errors && errors[name] !== undefined ? errors[name][0] : ''}
        name={name}
        label={label}
        type={type}
        variant='outlined'
        value={value || ''}
        onChange={onChange}
        select={select}
        disabled={!editable}
        multiline={multiline}
        rows={rows}
        InputLabelProps={inputLabelProps}
      >
        {children}
      </TextField>
    </div>
  );
}

TextInput.defaultProps = {
  type: 'text',
  errors: {},
  onChange: () => {
    return null;
  },
  children: <></>,
  select: false,
  editable: true,
  multiline: false,
  rows: 0,
  inputLabelProps: undefined,
};

export default TextInput;
